<template>
  <div class="content">
    <div>
      <img class="icon icon--link icon--bottom" src="@images/arrow-left.svg" v-svg-inline>
      <router-link :to="{ name: 'abiturient.index', params: { tab: 'applications' } }">Вернуться назад</router-link>
    </div>

    <div v-if="store.loading" class="content content--center">
      <p>Загрузка...</p>
    </div>

    <application-layout v-else @refetch="onRefetch"/>
  </div>
</template>

<script setup>
import { onBeforeMount } from 'vue'
import { useRoute } from 'vue-router'
import { ApplicationLayout, useApplicationStore } from '@widgets/application-profile'

const route = useRoute()
const store = useApplicationStore()

onBeforeMount(() => store.fetchForAbiturient(route.params.id))
const onRefetch = () => store.fetchForAbiturient(route.params.id, true)
</script>
